export const MARKET_PLACE_IDS = [
  { display: 'North American Integration', val: 'NA' },
  { display: 'European Integration', val: 'EU' },
  // NA
  { display: '(US) ATVPDKIKX0DER', val: 'ATVPDKIKX0DER' },
  { display: '(CA) A2EUQ1WTGCTBG2', val: 'A2EUQ1WTGCTBG2' },
  { display: '(MX) A1AM78C64UM0Y8', val: 'A1AM78C64UM0Y8' },
  // EU
  { display: '(UK) A1F83G8C2ARO7P', val: 'A1F83G8C2ARO7P' },
  { display: '(DE) A1PA6795UKMFR9', val: 'A1PA6795UKMFR9' },
  { display: '(FR) A13V1IB3VIYZZH', val: 'A13V1IB3VIYZZH' },
  { display: '(ES) A1RKKUPIHCS9HS', val: 'A1RKKUPIHCS9HS' },
  { display: '(IT) APJ6JRA9NG5V4', val: 'APJ6JRA9NG5V4' },
  { display: '(NL) A1805IZSGTT6HS', val: 'A1805IZSGTT6HS' },
  { display: '(BE) AMEN7PMS3EDWL', val: 'AMEN7PMS3EDWL' },
  { display: '(SE) A2NODRKZP88ZB9', val: 'A2NODRKZP88ZB9' },
  { display: '(PL) A1C3SOZRARQ6R3', val: 'A1C3SOZRARQ6R3' },
  { display: '(TR) A33AVAJ2PDY3EV', val: 'A33AVAJ2PDY3EV' },
  { display: '(EG) ARBP9OOSHTCHU', val: 'ARBP9OOSHTCHU' },
  { display: '(SA) A17E79C6D8DWNP', val: 'A17E79C6D8DWNP' },
  { display: '(AE) A2VIGQ35RCS4UG', val: 'A2VIGQ35RCS4UG' },
  { display: '(IN) A21TJRUUN4KGV', val: 'A21TJRUUN4KGV' },
];

export const EU_MARKET_PLACE_IDS = [
  { display: 'United Kingdom', val: 'A1F83G8C2ARO7P' },
  { display: 'Germany', val: 'A1PA6795UKMFR9' },
  { display: 'France', val: 'A13V1IB3VIYZZH' },
  { display: 'Spain', val: 'A1RKKUPIHCS9HS' },
  { display: 'Italy', val: 'APJ6JRA9NG5V4' },
  { display: 'Netherlands', val: 'A1805IZSGTT6HS' },
  { display: 'Belgium', val: 'AMEN7PMS3EDWL' },
  { display: 'Sweden', val: 'A2NODRKZP88ZB9' },
  { display: 'Poland', val: 'A1C3SOZRARQ6R3' },
  { display: 'Turkey', val: 'A33AVAJ2PDY3EV' },
  { display: 'Egypt', val: 'ARBP9OOSHTCHU' },
  { display: 'Saudi Arabia', val: 'A17E79C6D8DWNP' },
  { display: 'United Arab Emirates', val: 'A2VIGQ35RCS4UG' },
  { display: 'India', val: 'A21TJRUUN4KGV' },
];

export const MIXED_MARKETPLACES = [
  // North America Specific Region
  {
    isGroup: true,
    region: 'North America',
    markets: [
      { display: 'North American Integration', val: 'NA' },
      { display: '(US) ATVPDKIKX0DER', val: 'ATVPDKIKX0DER' },
      { display: '(CA) A2EUQ1WTGCTBG2', val: 'A2EUQ1WTGCTBG2' },
      { display: '(MX) A1AM78C64UM0Y8', val: 'A1AM78C64UM0Y8' },
    ]
  },

  // Europe Specific Region
  {
    isGroup: true,
    region: 'Europe',
    markets: [
      { display: 'European Integration', val: 'EU' },
      { display: '(UK) A1F83G8C2ARO7P', val: 'A1F83G8C2ARO7P' },
      { display: '(DE) A1PA6795UKMFR9', val: 'A1PA6795UKMFR9' },
      { display: '(FR) A13V1IB3VIYZZH', val: 'A13V1IB3VIYZZH' },
      { display: '(ES) A1RKKUPIHCS9HS', val: 'A1RKKUPIHCS9HS' },
      { display: '(IT) APJ6JRA9NG5V4', val: 'APJ6JRA9NG5V4' },
      { display: '(NL) A1805IZSGTT6HS', val: 'A1805IZSGTT6HS' },
      { display: '(BE) AMEN7PMS3EDWL', val: 'AMEN7PMS3EDWL' },
      { display: '(SE) A2NODRKZP88ZB9', val: 'A2NODRKZP88ZB9' },
      { display: '(PL) A1C3SOZRARQ6R3', val: 'A1C3SOZRARQ6R3' },
      { display: '(TR) A33AVAJ2PDY3EV', val: 'A33AVAJ2PDY3EV' },
      { display: '(EG) ARBP9OOSHTCHU', val: 'ARBP9OOSHTCHU' },
      { display: '(SA) A17E79C6D8DWNP', val: 'A17E79C6D8DWNP' },
      { display: '(AE) A2VIGQ35RCS4UG', val: 'A2VIGQ35RCS4UG' },
      { display: '(IN) A21TJRUUN4KGV', val: 'A21TJRUUN4KGV' },
    ]
  }
];
